import meta from '../helper/meta';
import JSONParser from '../helper/json-parser';
import sendBeacon from "../helper/send-beacon";
import Logger from "./logger";
import TrackingHelper from './tracking/helper';

// Landmark-Handlers
import click from './tracking/landmarks/click';
import navi from './tracking/landmarks/click';
import view from './tracking/landmarks/view';
import page from './tracking/landmarks/page';
import cursor from './tracking/landmarks/cursor';
import browser from './tracking/landmarks/browser';
import visible from './tracking/landmarks/visible';
import layer_view from './tracking/landmarks/visible';
import naviswipe from './tracking/landmarks/naviswipe';

const HANDLERS = {
    click,
    view,
    layer_view,
    page,
    navi,
    cursor,
    browser,
    visible,
    naviswipe
};
const LANDMARK_CONTROLLER_URL = meta.value('landmark:url');
const LANDMARK_CONTROLLER_URL_NEW_SERVICE = meta.value('landmarkNewService:url');
const NUMBER_PATTERN = /^\d+$/;

function initialize(element) {
    for (const landmarkType in HANDLERS) {
        let landmarkConfigOrString = element.getAttribute(`jsh-landmark__${landmarkType}`);
        if (landmarkConfigOrString === null) {
            continue;
        }
        landmarkConfigOrString = sanitize(landmarkConfigOrString);
        const landmarkHandler = HANDLERS[landmarkType];
        let parsedLandmarkConfig = JSONParser.tryParseJSON(landmarkConfigOrString);
        const isNumber = NUMBER_PATTERN.test(landmarkConfigOrString);
        const isLandmarkConfigNotJson = parsedLandmarkConfig === null || isNumber;
        if (isLandmarkConfigNotJson) {
            parsedLandmarkConfig = {
                [landmarkType]: landmarkConfigOrString
            };
        }
        landmarkHandler(element, parsedLandmarkConfig, sendLandmark);
    }
}

function sendUserInfoLandmark() {
    sendLandmark({
        landmark: 'userinfo',
        landscape: window.innerHeight > window.innerWidth,
    });
}

function sendClickLandmark(value) {
    sendLandmark({
        landmark: "userinterface",
        click: value
    });
}

function sendUserInterfaceLandmark(landmarkData) {
    sendLandmark({
        landmark: "userinterface",
        ...landmarkData
    });
}

function sendVisibleLandmark(value) {
    sendLandmark({
        landmark: "action",
        visible: value
    });
}

function sendActionLandmark(value) {
    sendLandmark({
        landmark: "action",
        ...value
    })
}

function sendCarouselLandmark(landmarkData) {
    if(!landmarkData) {
        return;
    }
    sendLandmark({landmark: "carousel", ...landmarkData});
}

function sendLandmark(data) {
    const landmarkName = data.landmark;
    const implicitLandmarkDataHolder = implicitLandmarkData();
    const dataWithImplicitLandmarkData = Object.assign({}, implicitLandmarkDataHolder, data);

    delete dataWithImplicitLandmarkData.landmark;

    if (!sendBeacon(`${LANDMARK_CONTROLLER_URL}${landmarkName}/`, dataWithImplicitLandmarkData)) {
        Logger.error(`Could not send landmark!\n\tReason: Unknown (beacon)\n\tLandmark name: ${landmarkName}`)
    }
}

function sendPageLandmark(data) {
    return page(null, data, sendLandmark);
}

export default {
    initialize,
    sendUserInfoLandmark,
    sendLandmark,
    sendCarouselLandmark,
    sendClickLandmark,
    sendPageLandmark,
    sendUserInterfaceLandmark,
    sendVisibleLandmark,
    sendActionLandmark
};

function implicitLandmarkData() {
    let data = {
        pwkorbid: TrackingHelper.getSessionId(),
        uid: TrackingHelper.getUserId(),
        pageViewId: TrackingHelper.getPageViewId(),
        pAnbieter: TrackingHelper.getTenantId(),
        origin: "RWD",
        cursor: localStorage.cursorValue ? localStorage.cursorValue : "",
        eventId: TrackingHelper.generateUUID()
    };

    if (TrackingHelper.getSubSessionId() !== '') {
        data.psubwkorbid = TrackingHelper.getSubSessionId();
    }

    return data;
}

function sanitize(inputString) {
    if (inputString === undefined) {
        return '';
    }
    return inputString.replace(/\r?\n|\r/g, "");
}
